//Custom components

import ReviewCard from './ReviewCard';

//Services
import { useApplicationFormContext } from 'features/ApplicationForm/ApplicationFormProvider';

export default function Review() {
  const { setCurrentStep, data } = useApplicationFormContext();

  const {
    application,
    householdIncome,
    propertyInformation,
    applicationInformation,
  } = data;

  return (
    <div className={`space-y-5 px-6 py-4 lg:col-span-9`}>
      <ReviewCard
        title="Application Information"
        handleEdit={() => setCurrentStep(0)}>
        <dl>
          <div className="bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-500">Name</dt>
            <dd className="mt-1 text-sm text-gray-900 capitalize sm:mt-0 sm:col-span-2">
              {application?.name}
            </dd>
          </div>

          <div className="bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-500">
              Street Address
            </dt>
            <dd className="mt-1 text-sm text-gray-900 normal-case sm:mt-0 sm:col-span-2">
              {application?.streetAddress}
            </dd>
          </div>

          <div className="bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-500">City</dt>
            <dd className="mt-1 text-sm text-gray-900 capitalize sm:mt-0 sm:col-span-2">
              {application?.city}
            </dd>
          </div>
          <div className="bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-500">
              State / Province
            </dt>
            <dd className="mt-1 text-sm text-gray-900 normal-case sm:mt-0 sm:col-span-2">
              {application?.state}
            </dd>
          </div>
          <div className="bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-500">
              Zip / Postal Code
            </dt>
            <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
              {application?.zipCode}
            </dd>
          </div>
          <div className="bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-500">Home Work</dt>
            <dd className="mt-1 text-sm text-gray-900 capitalize sm:mt-0 sm:col-span-2">
              {application?.homePhone}
            </dd>
          </div>
          <div className="bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-500">Work Phone</dt>
            <dd className="mt-1 text-sm text-gray-900 capitalize sm:mt-0 sm:col-span-2">
              {application?.workPhone}
            </dd>
          </div>
          <div className="bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-500">Other Phone</dt>
            <dd className="mt-1 text-sm text-gray-900 capitalize sm:mt-0 sm:col-span-2">
              {application?.otherPhone}
            </dd>
          </div>
          <div className="bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-500">Date Of Birth</dt>
            <dd className="mt-1 text-sm text-gray-900 capitalize sm:mt-0 sm:col-span-2">
              {application?.dob}
            </dd>
          </div>
          <div className="bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-500">
              Last Four Social
            </dt>
            <dd className="mt-1 text-sm text-gray-900 capitalize sm:mt-0 sm:col-span-2">
              {application?.lastFourSocial}
            </dd>
          </div>
          <div className="bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-500">Gender</dt>
            <dd className="mt-1 text-sm text-gray-900 capitalize sm:mt-0 sm:col-span-2">
              {application?.gender}
            </dd>
          </div>
          <div className="bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-500">
              Marital Status
            </dt>
            <dd className="mt-1 text-sm text-gray-900 capitalize sm:mt-0 sm:col-span-2">
              {application?.maritalStatus}
            </dd>
          </div>
          <div className="bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-500">
              Marital Status
            </dt>
            <dd className="mt-1 text-sm text-gray-900 capitalize sm:mt-0 sm:col-span-2">
              {application?.disabled}
            </dd>
          </div>
          <div className="bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-500">City Employee</dt>
            <dd className="mt-1 text-sm text-gray-900 capitalize sm:mt-0 sm:col-span-2">
              {application?.cityEmployee}
            </dd>
          </div>
          <div className="bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-500">Race</dt>
            <dd className="mt-1 text-sm text-gray-900 capitalize sm:mt-0 sm:col-span-2">
              {application?.race?.map((d: string) => d)}
            </dd>
          </div>
        </dl>
      </ReviewCard>
      {householdIncome?.length > 0 && (
        <ReviewCard
          title="List of properties you own"
          handleEdit={() => setCurrentStep(1)}>
          {householdIncome?.map((income: any) => (
            <div className="bg-white pt-5">
              <div className="border rounded p-5 bg-white">
                <h6 className="text-sm normal-case">
                  {income?.familyMemberName}
                </h6>
                <small className="text-gray-400">{`${income.age}, ${income.relation}, ${income?.wages}`}</small>
              </div>
            </div>
          ))}
        </ReviewCard>
      )}
      <ReviewCard
        title="Application Information"
        handleEdit={() => setCurrentStep(2)}>
        <dl>
          <div className="bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-500">
              Street Address
            </dt>
            <dd className="mt-1 text-sm text-gray-900 normal-case sm:mt-0 sm:col-span-2">
              {propertyInformation?.streetAddress}
            </dd>
          </div>

          <div className="bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-500">City</dt>
            <dd className="mt-1 text-sm text-gray-900 capitalize sm:mt-0 sm:col-span-2">
              {propertyInformation?.city}
            </dd>
          </div>
          <div className="bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-500">
              State / Province
            </dt>
            <dd className="mt-1 text-sm text-gray-900 normal-case sm:mt-0 sm:col-span-2">
              {propertyInformation?.state}
            </dd>
          </div>
          <div className="bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-500">
              Zip / Postal Code
            </dt>
            <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
              {propertyInformation?.zipCode}
            </dd>
          </div>

          <div className="bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-500">Work Phone</dt>
            <dd className="mt-1 text-sm text-gray-900 capitalize sm:mt-0 sm:col-span-2">
              {propertyInformation?.workPhone}
            </dd>
          </div>
          <div className="bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-500">Buyers Name</dt>
            <dd className="mt-1 text-sm text-gray-900 capitalize sm:mt-0 sm:col-span-2">
              {propertyInformation?.buyersAgentName}
            </dd>
          </div>
          <div className="bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-500">
              Buyers Work Phone
            </dt>
            <dd className="mt-1 text-sm text-gray-900 capitalize sm:mt-0 sm:col-span-2">
              {propertyInformation?.workPhone}
            </dd>
          </div>
          <div className="bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-500">
              Buyers Agent Email
            </dt>
            <dd className="mt-1 text-sm text-gray-900 capitalize sm:mt-0 sm:col-span-2">
              {propertyInformation?.buyersAgentEmail}
            </dd>
          </div>
          <div className="bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-500">Sellers Name</dt>
            <dd className="mt-1 text-sm text-gray-900 capitalize sm:mt-0 sm:col-span-2">
              {propertyInformation?.sellersName}
            </dd>
          </div>
          <div className="bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-500">
              Sellers Agent Name
            </dt>
            <dd className="mt-1 text-sm text-gray-900 capitalize sm:mt-0 sm:col-span-2">
              {propertyInformation?.sellersName}
            </dd>
          </div>
          <div className="bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-500">
              Sellers Work Phone
            </dt>
            <dd className="mt-1 text-sm text-gray-900 capitalize sm:mt-0 sm:col-span-2">
              {propertyInformation?.sellersWorkPhone}
            </dd>
          </div>
          <div className="bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-500">
              Sellers Agent Email
            </dt>
            <dd className="mt-1 text-sm text-gray-900 capitalize sm:mt-0 sm:col-span-2">
              {propertyInformation?.sellersAgentEmail}
            </dd>
          </div>
        </dl>
      </ReviewCard>

      <ReviewCard title="Attachments" handleEdit={() => setCurrentStep(3)}>
        <dl>
          <div className="bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-500">
              1st Mortgage Pre-Approval Letter
            </dt>
            {applicationInformation?.approvalLetter?.map((d: any) => (
              <dd className="mt-1 text-sm text-gray-900 normal-case sm:mt-0 sm:col-span-2">
                {d.name}
              </dd>
            ))}
          </div>
          <div className="bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-500">
              Most Recent Tax Return
            </dt>
            {applicationInformation?.taxReturn?.map((d: any) => (
              <dd className="mt-1 text-sm text-gray-900 normal-case sm:mt-0 sm:col-span-2">
                {d.name}
              </dd>
            ))}
          </div>
          <div className="bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-500">
              Two Months of Most Recent Pay Stubs
            </dt>
            {applicationInformation?.payStubs?.map((d: any) => (
              <dd className="mt-1 text-sm text-gray-900 normal-case sm:mt-0 sm:col-span-2">
                {d.name}
              </dd>
            ))}
          </div>
          <div className="bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-500">
              3 Months of Bank Statements
            </dt>
            {applicationInformation?.bankStatements?.map((d: any) => (
              <dd className="mt-1 text-sm text-gray-900 normal-case sm:mt-0 sm:col-span-2">
                {d.name}
              </dd>
            ))}
          </div>
        </dl>
      </ReviewCard>
    </div>
  );
}
